import React, { useState } from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import OverlayButton from '../OverlayButton';
import ConfirmationModal from '../ConfirmationModal';

const propTypes = {
  site: PropTypes.shape({
    blogSettings: PropTypes.shape({
      enabled: PropTypes.bool.isRequired,
    }).isRequired,
  }).isRequired,
  loading: PropTypes.bool.isRequired,
  toggleBlog: PropTypes.func.isRequired,
  toggling: PropTypes.bool.isRequired,
};
const defaultProps = {};

const ToggleButton = ({
  site: { blogSettings: { enabled } },
  loading,
  toggleBlog,
  toggling,
}) => {
  const [showModal, setShowModal] = useState(false);
  if (loading) {
    return null;
  }

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  const onClickToggle = async () => {
    setShowModal(false);
    toggleBlog(!enabled);
  };

  return (
    <React.Fragment>
      <OverlayButton
        data-testid="activationBtn"
        size="sm"
        context="neutral"
        loading={toggling}
        onClick={toggleModal}
      >
        {enabled ? 'Deactivate' : 'Activate'}
      </OverlayButton>
      <ConfirmationModal
        buttonText={enabled ? 'Deactivate' : 'Activate'}
        title={`${enabled ? 'Deactivating' : 'Activating'} the Blog`}
        onConfirm={onClickToggle}
        show={showModal}
        onDismiss={toggleModal}
      >
        Are you sure you want to {enabled ? 'deactivate' : 'activate'} your blog?
      </ConfirmationModal>
    </React.Fragment>
  );
};

ToggleButton.propTypes = propTypes;
ToggleButton.defaultProps = defaultProps;

ToggleButton.fragments = {
  currentSite: gql`
    fragment CurrentSiteBlogDataToggleButton on Site {
      blogSettings {
        enabled
        homepage(locale: $locale) {
          id
          live
        }
      }
    }
  `,
};

export default ToggleButton;
